import React from 'react';
import { Box, Skeleton } from '@mui/material';

const LEGEND_ITEMS = 4;
const Y_AXIS_TICKS = 6;
const X_AXIS_TICKS = 12;

const AreaChartSkeleton: React.FC = () => (
  <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
    <Box sx={{ display: 'flex', flexDirection: 'row', width: '100%', px: '1rem', py: '0.25rem' }}>
      {/* Y-axis tick stubs */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          pr: '0.5rem',
        }}
      >
        {Array.from({ length: Y_AXIS_TICKS }).map((_, i) => (
          <Skeleton
            key={i}
            variant="rectangular"
            width="1.75rem"
            height="0.5rem"
            sx={{ borderRadius: '4px', mb: '1rem' }}
          />
        ))}
      </Box>

      <Box sx={{ flex: 1 }}>
        {/* Chart area body */}
        <Skeleton
          variant="rectangular"
          width="100%"
          height="12rem"
          sx={{ borderRadius: '0.5rem' }}
        />

        {/* X-axis tick stubs */}
        <Box
          sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', mt: '0.75rem' }}
        >
          {Array.from({ length: X_AXIS_TICKS }).map((_, i) => (
            <Skeleton
              key={i}
              variant="rectangular"
              width="1.5rem"
              height="0.5rem"
              sx={{ borderRadius: '4px' }}
            />
          ))}
        </Box>
      </Box>
    </Box>

    {/* Legend row */}
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: '0.75rem',
        px: '1rem',
        pt: '0.75rem',
        pb: '0.5rem',
      }}
    >
      {Array.from({ length: LEGEND_ITEMS }).map((_, i) => (
        <Box key={i} sx={{ display: 'flex', alignItems: 'center', gap: '0.375rem' }}>
          <Skeleton variant="circular" width="0.75rem" height="0.75rem" />
          <Skeleton
            variant="rectangular"
            width="4rem"
            height="0.625rem"
            sx={{ borderRadius: '4px' }}
          />
        </Box>
      ))}
    </Box>
  </Box>
);

export default AreaChartSkeleton;
